/** Preferências de exibição das imagens do satélite. */
import { create } from 'zustand';

interface DisplayState {
  /**
   * Mostrar a faixa de rodapé da NOAA (data e créditos gravados na imagem).
   * Desligada por padrão: com zoom ela fica enorme e, com camadas empilhadas,
   * os textos se sobrepõem. Os créditos continuam na atribuição do mapa.
   */
  showNoaaFooter: boolean;
  set: (patch: Partial<Omit<DisplayState, 'set'>>) => void;
}

export const useDisplayStore = create<DisplayState>()((set) => ({
  showNoaaFooter: false,
  set: (patch) => set(patch),
}));
